export default {
    title: 'Log In',
    subtitle: "Don't have an account?",
    sign_up: 'Sign Up',
    resend: 'Resend verification email',
    messages: {
        success: 'Email verified successfully!',
        error: 'Your session has expired!',
        invalid: 'Invalid email or password!',
        unverified: "Didn't receive the email?",
        invited: 'Invite accepted successfully!',
        user_already_part_of_the_company: "You're already part of the company",
        token_invalid: 'The request is not valid',
        verification_email_sent: 'Verification email sent',
        user_is_not_part_of_the_company: "You're not part of this company",
        invitation_unkown_or_used: 'Invitation is already used or invalid',
        email_already_verified: 'Email already verified!',
    },
    activating: 'Activating your account...',
}
